import React from "react";
import { Link } from "react-router-dom";

// Island names that have dedicated destination landing pages.
const MAP = [
  ["St. Vincent and the Grenadines", "/st-vincent"],
  ["St. Vincent", "/st-vincent"],
  ["Grenada", "/grenada"],
  ["Barbados", "/barbados"],
];

const escaped = MAP.map(([p]) => p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
const pattern = new RegExp("(" + escaped.join("|") + ")", "gi");

// Splits text and wraps any known island name in a Link to its destination page.
export function renderWithLinks(text) {
  if (!text) return null;
  const parts = text.split(pattern);
  return parts.map((part, i) => {
    const hit = MAP.find(([p]) => p.toLowerCase() === part.toLowerCase());
    if (hit) {
      return (
        <Link key={i} to={hit[1]} className="text-cyan-400 hover:underline font-semibold">
          {part}
        </Link>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export function tagLink(tag) {
  const hit = MAP.find(([p]) => p.toLowerCase() === tag.toLowerCase());
  return hit ? hit[1] : `/browse?q=${encodeURIComponent(tag)}`;
}
